/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Jan 2023
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import Whiteboard from '../../../Playground/components/Body/Whiteboard';
import classes from './Layout.module.css';
import ShapeInfoPopup from "../../../Fireboard/components/ShapeInfoPopup";

const Layout = ({
  shapes,
  onSelectShape,
  selectedItem,
  selectedShape,
  closeShapeInfoPopup,
  openMergeStationPopup,
  invokeTableUnmerge,
  onClickInfo,
  onClickSms,
  selectedTableChecks,
  showHelpPopup,
  transferTable,
  openTableMenu,
  onVoidCheck,
}) => {

  const isObjectBlank = obj => {
    return !(obj && Object.keys(obj).length !== 0 && obj.constructor === Object);
  };

  return (
    <div className={classes.container}>
      <Whiteboard
        draggable={false}
        shapes={shapes}
        selectShape={onSelectShape}
        backgroundColor={'#2a2a2a'}
        tableInfoColumn='stationNumber'
        keyName1='openTime'
        keyName2_primary='closedTime'
        keyName2_secondary='totalAmount'
        keyName3='guestCount'
      />
      {selectedShape && !isObjectBlank(selectedItem) && (
        <ShapeInfoPopup
          x={selectedShape?.x}
          y={selectedShape?.y}
          selectedCheck={selectedItem}
          onClose={closeShapeInfoPopup}
          tmsView
          unseatGuest={selectedItem.unseatGuest}
          selectedShape={selectedShape}
          openMergeStationPopup={openMergeStationPopup}
          invokeTableUnmerge={invokeTableUnmerge}
          onClickInfo={(Array.isArray(selectedTableChecks) && selectedTableChecks.length) ? onClickInfo : null}
          onClickSms={onClickSms}
          showHelpPopup={showHelpPopup}
          transferTable={transferTable}
          openTableMenu={openTableMenu}
          onVoidCheck={onVoidCheck}
        />
      )}
    </div>
  );
};

export default Layout;

Layout.propTypes = {
  shapes: PropTypes.array,
  onSelectShape: PropTypes.func,
  onClickInfo: PropTypes.func,
};

Layout.defaultProps = {
  shapes: [],
  onSelectShape: () => { },
  onClickInfo: () => { },
};
